<script setup>
/* Suchfeld der Startansicht. Jede Seite hat ihr eigenes Feld, der Suchtext (query in usePlayers.js)
   ist aber derselbe: Er gilt für die jeweils aktive Seite. */
import { ref } from 'vue';
import { mdiClose } from '@mdi/js';
import { usePlayers } from '../composables/usePlayers.js';

const { query } = usePlayers();
const input = ref(null);

/* Leert das Feld (X-Knopf und Esc) und setzt den Fokus zurück ins Feld */
function clear() {
  query.value = '';
  input.value?.focus?.();
}

/* Esc leert nur, wenn Text drinsteht; sonst bleibt die Taste unberührt (z. B. für Dialoge) */
function onEscape(e) {
  if (!query.value) return;
  e.preventDefault();
  clear();
}
</script>

<template>
  <div class="toolbar" :class="{ 'has-actions': !!$slots.default }">
    <div class="search">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#7C8D9C" stroke-width="2">
        <circle cx="11" cy="11" r="7" />
        <path d="M21 21l-4.3-4.3" />
      </svg>
      <!-- type="search" + enterkeyhint: Die Handy-Tastatur zeigt "Suchen" statt
           "Weiter" und springt nicht ins nächste Feld. Gefiltert wird schon
           beim Tippen; Enter schließt nur die Tastatur (Blur). -->
      <input
        ref="input"
        v-model="query"
        type="search"
        enterkeyhint="search"
        autocomplete="off"
        :placeholder="$t('squad.searchPlaceholder')"
        :aria-label="$t('squad.searchPlaceholder')"
        @keydown.enter.prevent="$event.target.blur()"
        @keydown.esc="onEscape"
      />
      <button
        v-if="query"
        type="button"
        class="search-clear"
        :aria-label="$t('squad.clearSearch')"
        :title="$t('squad.clearSearch')"
        @click="clear"
      >
        <v-icon :icon="mdiClose" size="18" />
      </button>
    </div>
    <!-- Knöpfe neben der Suche (Kaderseite: Filter, Spielerzahl, Select) -->
    <slot />
  </div>
</template>

<style scoped>
/* Klickfläche 44 px; negativer Außenabstand, damit das Feld nicht höher wird als zuvor */
.search-clear {
  flex: none;
  width: 44px;
  height: 44px;
  margin: -14px -14px -14px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 10px;
  color: var(--muted);
  cursor: pointer;
  transition: color 0.14s;
}
.search-clear:hover {
  color: var(--text);
}
.search-clear:focus-visible {
  outline: 2px solid var(--green);
  outline-offset: -2px;
}
/* Das eigene X des Browsers (WebKit) ausblenden — es gibt nur noch unseres */
.search input[type='search']::-webkit-search-cancel-button {
  -webkit-appearance: none;
  appearance: none;
  display: none;
}
</style>
